import React from 'react';
import PropTypes from 'prop-types';
import { useConnect, UseQueryConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import Avatar from '../../../components/Avatar';
import useDialogLauncher from '../../../dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';

Questions.propTypes = {
  project: PropTypes.object.isRequired
};

export default function Questions(props) {
  const { project } = props;

  const MAX_CONVERSATIONS = 7;

  const launch = useDialogLauncher();

  function onClick(user) {
    launch(DialogManager.User.Config(user.id));
  }

  const responses = [
    'Connect',
    // 'Pending'
  ];

  const questions = useConnect('question.find', {
    where: {
      eager: {
        $where: {
          projectId: project.id,
          response: {
            $in: responses
          }
        }
      }
    }
  });

  if (questions.state === PayloadStates.FETCHING) {
    return (
      <Loader/>
    );
  }

  function Circle(props) {
    return (
      <div className="h-8 w-8 bg-cs-orange-200 rounded-full text-cs-gray-900 flex items-center text-sm justify-center">
        {props.children}
      </div>
    );
  }

  if (questions.data.length > 0) {
    return (
      <div className="flex space-x-2">
        {questions.data.slice(0,MAX_CONVERSATIONS).map(function(question, index) {
          return (
            <UseQueryConnect key={index} _key="user.byId" params={{ id: question.data.userId }}>
              {function(user) {
                return (
                  <Avatar
                    key={index}
                    size={8}
                    src={user.data.avatarUrl}
                    tooltip={`${user.data.firstName} ${user.data.lastName}`}
                    onClick={() => onClick(user)}
                  />
                );
              }}
            </UseQueryConnect>
          );
        })}
        {questions.data.slice(MAX_CONVERSATIONS).length > 0 && (
          <Circle>
            +{questions.data.slice(MAX_CONVERSATIONS).length}
          </Circle>
        )}
      </div>
    );
  }

  return null;
}
